.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  transition: transform var(--aura-motion-duration-fast) var(--aura-motion-easing-standard);
}

.iconOpen {
  transform: rotate(45deg);
}

.iconContainer {
  position: relative;
  width: 100%;
  height: 100%;
}

.iconLayer {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity var(--aura-motion-duration-fast) var(--aura-motion-easing-standard),
    transform var(--aura-motion-duration-fast) var(--aura-motion-easing-standard);
  opacity: 0;
  transform: scale(0.6);
}

.iconLayerActive {
  opacity: 1;
  transform: scale(1);
}

@media (prefers-reduced-motion: reduce) {
  .icon,
  .iconLayer {
    transition: none;
  }
}
